export const agenciesMercedes = [
  8, //Mercedes Benz Eurostern López Mateos
  12, //Mercedes Benz Minerva
  32, //Mercedes Benz Patria
];
